import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

interface Props {
    children?: React.ReactNode
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 0,
            staleTime: 0,
            gcTime: 0,
        },
    },
})

export const QueryProvider: React.FC<Props> = ({ children }) => {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
